// extracted by mini-css-extract-plugin
export default {"ppt_step1":"step1_ppt_step1__GG9s4","tag":"step1_tag__LI9bB","active":"step1_active__A61s-","geneBtn":"step1_geneBtn__9n5eG"};